import {Controller} from "@hotwired/stimulus"

// Every render of a login page mints a new state cookie; rewrite it on tap so it matches the link actually used.
export class IdAustriaStateController extends Controller {
	store() {
		const state = new URL(this.element.href).searchParams.get("state")
		const secure = location.protocol === "https:" ? "; Secure" : ""
		document.cookie = `id_austria_state=${state}; path=/; SameSite=Lax${secure}`
	}
}
